export default __webpack_public_path__ + "static/media/running.27b3efb4.jpg";